module.exports = __webpack_public_path__ + "img/livingroom.9dc2ac32.png";